/** Format a numeric amount as GBP for display (e.g. £1,234.56). */
export function formatMoney(value) {
  const num = typeof value === 'number' ? value : parseFloat(value);
  if (Number.isNaN(num)) {
    return '£0.00';
  }
  return `£${num.toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
